__turbopack_context__.v({
  "Content": "Story-module-sass-module__7K_VmW__Content",
  "Copy": "Story-module-sass-module__7K_VmW__Copy",
  "Image": "Story-module-sass-module__7K_VmW__Image",
  "Story": "Story-module-sass-module__7K_VmW__Story",
});
